import { render, staticRenderFns } from "./Lgx02828133041026541551671.vue?vue&type=template&id=f5f94e9c&"
import script from "./Lgx02828133041026541551671.vue?vue&type=script&lang=js&"
export * from "./Lgx02828133041026541551671.vue?vue&type=script&lang=js&"
import style0 from "./Lgx02828133041026541551671.vue?vue&type=style&index=0&id=f5f94e9c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports